import { render, staticRenderFns } from "./Lohnansaetze.vue?vue&type=template&id=73027b9a&"
import script from "./Lohnansaetze.vue?vue&type=script&lang=js&"
export * from "./Lohnansaetze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports